import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AlertConfigForm from './Alerts/AlertConfigForm';
import AlertPreview from './AlertPreview';
import { parseReceiverEmails } from './Alerts/receiverEmails';
import { mixpanelTrack } from 'utils/app';
import toast from 'react-hot-toast';
import { useCreateAlertConfig } from 'utils/hooks/alerts';
import { useQueryClient } from 'react-query';

function AlertConfigWrapper({ children }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-[25rem_1fr] md:h-[calc(100svh)] md:max-h-[calc(100svh)] md:overflow-hidden">
            {children}
        </div>
    );
}

function AlertCreate() {
    const createConfig = useCreateAlertConfig();
    const history = useHistory();
    const location = useLocation();
    const queryClient = useQueryClient();

    // Get duplicateFrom state if navigating from duplicate action
    const duplicateFrom = location.state?.duplicateFrom;
    const [previewConfig, setPreviewConfig] = useState(duplicateFrom || {});

    // Track page view
    useEffect(() => {
        mixpanelTrack('Alert Create View', {
            isDuplicate: !!duplicateFrom,
        });
    }, []);

    useEffect(() => {
        setPreviewConfig(duplicateFrom || {});
    }, [duplicateFrom]);

    const handleCreate = async (formData) => {
        try {
            const newConfig = await createConfig.mutateAsync(formData);
            await queryClient.invalidateQueries('alertConfigs');
            await queryClient.refetchQueries('alertConfigs');

            mixpanelTrack('Create Alert', {
                alertConfigId: newConfig.alert_config_id,
                numberOfRecipients: parseReceiverEmails(
                    formData.receiver_emails,
                ).length,
                categories: formData.categories
                    ?.map((cat) => cat.cat3 || cat.cat2)
                    .filter(Boolean),
                country: formData.country,
                trendType: formData.trend_type,
                name: formData.name,
                brandName: formData.brand_name,
                brandWebsite: formData.website_url,
                dataSource: formData.data_source,
            });

            toast.success('Alert configuration created successfully!');
            history.push(`/alerts/${newConfig.alert_config_id}`);
        } catch (error) {
            console.error('Failed to create alert:', error);
            toast.error('Failed to create alert configuration');
        }
    };
    return (
        <AlertConfigWrapper>
            <AlertConfigForm
                config={duplicateFrom}
                onSubmit={handleCreate}
                isSubmitting={createConfig.isLoading}
                onConfigChange={setPreviewConfig}
            />
            <AlertPreview config={previewConfig} />
        </AlertConfigWrapper>
    );
}

export default AlertCreate;
